// import AddComplaints from "./AddComplaints";
import Complaints from "./Complaints";
import ComplaintsList from "./ComplaintsList";
import { createContext, useEffect, useState } from "react";
import { ComplaintsType, ComplaintContextType } from "./types";
export const ComplaintContext = createContext<ComplaintContextType>({
  list: [],
  setList: () => {},
  edit: null,
  setEdit: () => {},
});
const PatientComplaints = () => {
  const [list, setList] = useState<ComplaintsType[]>([]);
  const [edit, setEdit] = useState<ComplaintsType | null>(null);
  useEffect(() => {
    return () => {
      setList([]);
      setEdit(null);
    };
  }, []);
  return (
    <ComplaintContext.Provider value={{ list, setList, edit, setEdit }}>
      <div className="grid grid-cols-2 gap-2">
        <div className="col-span-full">
          <Complaints />
        </div>
        <div className="col-span-full">
          <ComplaintsList />
        </div>
      </div>
    </ComplaintContext.Provider>
  );
};

export default PatientComplaints;
